import { Provider } from "./Provider.jsx";

export * from "./context/index.jsx";

export default Provider;
